import { Root } from '@radix-ui/react-progress';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

import { ProgressProps } from './Progress.types';
import { ProgressIndicator } from './ProgressIndicator';

export function Progress({ className, value }: PropsWithClassName<ProgressProps>) {
  return (
    <Root className={cn('relative h-4 w-full overflow-hidden rounded-full bg-slate-100', className)}>
      <ProgressIndicator value={value} />
    </Root>
  );
}
